import { requestRegistMusic, requestDeleteMusic } from "@/apis/music_api";

import router from "@/router";

const state = {
  musicList: []
};

const getters = {
  getMusicList(state) {
    return state.musicList;
  }
};

const mutations = {
  MUSIC_LIST(state, data) {
    state.musicList = data.resultMusicList;
  },
  INIT_MUSIC(state) {
    state.musicList = [];
  }
};

const actions = {};

export default { mutations, state, actions, getters };
